export default function filterSelectSearch(input, value) {
  return value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}
